import { isNull } from 'lodash-es';
export class CareOrderBabyFormForPatientInfoPage {
    #careOrderBabyForm;
    constructor({ careOrderBabyForm }) {
        this.#careOrderBabyForm = careOrderBabyForm;
    }
    // #NOTES
    // for the number fields
    // 'null' is not a valid input value
    // so we convert it to empty string for data display
    get height() {
        const height = this.#careOrderBabyForm.height;
        return isNull(height) ? '' : height;
    }
    get weight() {
        const weight = this.#careOrderBabyForm.weight;
        return isNull(weight) ? '' : weight;
    }
    get age() {
        const age = this.#careOrderBabyForm.age;
        return isNull(age) ? '' : age;
    }
    get parsedSymptom() {
        const symptom = this.#careOrderBabyForm.symptom;
        if (!symptom)
            return '';
        const parsedSymptom = symptom.join(', ');
        return parsedSymptom;
    }
    get parsedTube() {
        const tube = this.#careOrderBabyForm.tube;
        if (!tube)
            return '';
        const parsedTube = tube.join(', ');
        return parsedTube;
    }
}
